import { apiBase } from "APIs/index";
import { notificationMiddleWare } from "utils/NotificationMiddleWare";

export const AI_getBoards = apiBase.createListInstance({
  endpoint: "/board",
  method: "get",
  reducer: "boardReducer",
  key: "id",
  reduxKey: "BoardData",
  listPath: "data.board_list",
  action: "GET_BOARD_LIST",
  onSuccess: (data) => data,
});

export const AI_addBoard = apiBase.createInstance({
  endpoint: "/board",
  method: "post",
  reducer: "boardReducer",
  reduxKey: "addBoardData",
  action: "ADD_BOARD",
  // middleware: notificationMiddleWare,
  // onSuccess: (data) => {
  //   AI_getBoards.updateAction(data.board);
  // },
});

export const AI_updateBoard = apiBase.createInstance({
  endpoint: "/board/{id}",
  method: "put",
  reducer: "boardReducer",
  reduxKey: "updateBoardData",
  action: "UPDATE_BOARD",
  // middleware: notificationMiddleWare,
  // onSuccess: (data) => {
  //   AI_getBoards.updateAction(data.board);
  // },
});

export const AI_deleteBoard = apiBase.createInstance({
  endpoint: "/board/{id}",
  method: "delete",
  reducer: "boardReducer",
  reduxKey: "deleteBoard",
  action: "DELETE_BOARD",
  middleware: notificationMiddleWare,
  // onSuccess: (data) => {
  //   AI_getBoards.updateAction(data.board);
  // },
});

export const AI_getArchived = apiBase.createListInstance({
  endpoint: "/archive",
  method: "get",
  reducer: "boardReducer",
  key: "id",
  reduxKey: "ArchivedData",
  action: "ARCHIVE_DATA",
});
